// extracted by mini-css-extract-plugin
export default {"title":"AddPage_title__9swkd","previewLink":"AddPage_previewLink__A0Xrn","wyswyg_editorWrap":"AddPage_wyswyg_editorWrap__ib7GY","meta":"AddPage_meta__-6M4O"};